/* eslint-disable */
import React, { Fragment, Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { TextField, MenuItem } from '@material-ui/core';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { withStyles, Theme, createStyles, makeStyles, createTheme } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import { ThemeProvider } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RequestCorrectionDialog from './RequestCorrectionDialog';
import Dialog from '@material-ui/core/Dialog';
import InputAdornment from '@material-ui/core/InputAdornment';
import ActionButtons from './ActionButtons';
import './Access.css';
import { useEffect } from 'react';
import { get } from 'lodash';
import ReturnRequestSnackbar from '../../common/components/CreatedEnquirySnackbar';
import FullscreenLoader from '../../common/components/FullscreenLoader';
import { editDealerService } from '../../services/editDealer.service';
import { dealerService } from '../../services/dealer.service';
import { filterFeatureData, checkFeatureAccess } from '../../common/components/util';
import CancelDialog from '../../common/components/cancelDialog';
import { getUserParameters } from '../../store/actions/dealer.action';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  title: {
    flex: '1 1 100%',
  },
}));

const theme = createTheme({
  palette: {
    primary: {
      main: '#1A9FE0'
    },
  },
});

const AntSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 60,
      height: 28,
      padding: 0,
    },
    switchBase: {
      padding: 5,
      color: '#FFFFFF',
    },
    thumb: {
      width: 17,
      height: 17,
    },
    track: {
      background: '#444444',
      opacity: '1 !important',
      borderRadius: '2rem',
      position: 'relative',
      '&:before, &:after': {
        display: 'inline-block',
        position: 'absolute',
        top: '50%',
        width: '50%',
        transform: 'translateY(-50%)',
        color: '#FFFFFF',
        textAlign: 'center',
        fontSize: 10,
        fontFamily: 'Nunito',
        fontWeight: 500
      },
      '&:before': {
        content: '"Yes"',
        left: 7,
        opacity: 0,
      },
      '&:after': {
        content: '"No"',
        right: 6,
      },
    },
    checked: {
      '&$switchBase': {
        color: '#FFFFFF',
        transform: 'translateX(33px)',
      },
      '& $thumb': {
        backgroundColor: '#FFFFFF',
      },
      '& + $track': {
        '&:before': {
          opacity: 1,
        },
        '&:after': {
          opacity: 0,
        }
      },
    },
  }),
)(Switch);

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function AccessKam(props: any) {
  const dispatch: Dispatch<any> = useDispatch();
  const [selectedTab, setselectedTab] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const { selectedNewDealer, isEditDealer, dealerDetails, userParameters }: any = useSelector((state: any) => state.dealer);
  const b2bUserId = get(selectedNewDealer, "createdByB2bUserId", "");
  const sapCustomerId = get(selectedNewDealer, "sapCustomerId", "");
  const [paramsdata, setparamsdata] = React.useState<any>([])
  const [openCancelDialog, setOpenCancelDialog] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [notfetchedInitialData, setnotfetchedInitialData] = React.useState(true);
  const [formSubmitted, setformSubmitted] = React.useState(false);
  const [isAlacAccess, setIsAlacAccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [dealerstatus, setStatus] = React.useState<any>("");
  const [sapAvailabilityChecked, setsapAvailabilityChecked] = React.useState<any>(false);
  const [customerTierType, setCustomerTierType] = React.useState<string>("");
  const [userType, setUserType] = React.useState<any>("");
  const [formData, setformData] = React.useState<any>({
    "featureAccessibility": []
  });
  const [pricingTier, setPricingTier] = React.useState<any>("");

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const classes = useStyles();

  useEffect(() => {
    loadInitialData();
    const userType = sessionStorage.getItem('userType');
    setUserType(userType);
  }, []);

  const handleopenCloseCancelDialog = (open?: boolean) => {
    setOpenCancelDialog(false);
  };

  function isAlacBrandAccess(data: any) {
    return data?.some((item: any) => item.organizationId === "2195" && item.isActive !== false);
  }

  const loadInitialData = async () => {
    let paramsData = await editDealerService.getAllAcessParams();
    let data = await editDealerService.getDealerDetails(sapCustomerId, 'dealerDetails,accessData');
    if (data && data.data) {
      if (data.data.customerTierType) {
        setCustomerTierType(data.data.customerTierType);
      }
      if (data.data.customerTierType === 'TBL Dealer' || data.data.customerTierType === 'Dealer') {
        dispatch(getUserParameters(data.data.sapCustomerId, data.data.b2bUserId));
      }

      setIsAlacAccess(isAlacBrandAccess(data?.data?.organizationIds));
      setformData(data.data)
      setsapAvailabilityChecked(true)
      if (data.data.featureAccessibility && Array.isArray(data.data.featureAccessibility)) {
        let allowedIds: any = [];
        setPricingTier(data.data.pricingTier);
        data.data.featureAccessibility.map((feature: any) => {
          if (feature.value) {
            // if (data.data.customerTierType === 'Workshop' && feature.featureCode === "VIEW_CR_STATUS") {
            // } else {
            allowedIds.push(feature.featureCode)
            // }
          }
        })
        if (paramsData && paramsData.data && paramsData.data[0] && paramsData.data[0].featureAccessibility) {
          let tempData = paramsData.data[0].featureAccessibility
          tempData.map((param: any) => {
            if (allowedIds.includes(param.featureCode)) {
              param.value = true
            } else {
              param.value = false
            }
            return param
          })
          if (sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" && sessionStorage.getItem('customerOnboardingType') !== "Dealer") {
            let filterData = filterFeatureData(tempData)
            setparamsdata(filterData)
          } else {
            setparamsdata(tempData)
          }
        } else {
          setparamsdata(paramsData.data[0].featureAccessibility)
        }
      }
      else {
        let featureData = paramsData.data[0].featureAccessibility;
        if (sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" && sessionStorage.getItem('customerOnboardingType') !== "Dealer") {
          featureData = filterFeatureData(featureData)
        }
        setparamsdata(featureData)
      }
      if (data.data.status) {
        setStatus(data.data.status);
      }
    }

    setnotfetchedInitialData(false)
  }

  const saveAccessTab = async () => {
    setformSubmitted(true);
    let featureData = paramsdata.filter((item: any) => item.value)
    if (sessionStorage.getItem('customerOnboardingType') === "TBL Dealer" || sessionStorage.getItem('customerOnboardingType') === "Dealer") {
      let accessRequired = checkFeatureAccess(featureData)
      if (accessRequired.length === 0) {
        setOpenErrorSnackbar(true);
        setOpenSnackbar(true);
        setSuccessMessage(`Choose at least one parameter "Tyres & Batteries" or "Part Search".`);
        return;
      }
    }
    let data: any = {
      "featureAccessibility": featureData,
      updateTargetCustomerTier: sessionStorage.getItem('customerOnboardingType')
    }

    if (customerTierType && customerTierType.toLowerCase() === 'dealer' || sessionStorage.getItem('customerOnboardingType') === "Dealer") {
      data.isExtendedDealer = isAlacAccess;
    }
    setnotfetchedInitialData(true)
    setLoading(true);
    const responseData = await editDealerService.saveUpdateAcessTab(sapCustomerId, formData.b2bUserId, data);
    setnotfetchedInitialData(false)
    if (responseData && responseData.message && responseData.message.status == "S") {
      props.setDataUpdated(false);
      setLoading(false);
      setOpenErrorSnackbar(false);
      setOpenSnackbar(true);
      setSuccessMessage(responseData.message.message);
    } else {
      setOpenErrorSnackbar(true);
      setLoading(false);
      setOpenSnackbar(true);
      setSuccessMessage(responseData.error ? responseData.error : "Something went Wrong");
    }
  }

  const isDisabled = (access: any) => {
    const customerType = sessionStorage.getItem('customerOnboardingType');
    const pricingTierValue = pricingTier.toLowerCase();

    // ✅ Only allow ANNEXURE_PARTS for Gold, Platinum, or Elite dealers
    if (
      customerType === "Dealer" &&
      access.featureCode === "ANNEXURE_PARTS" &&
      !["gold", "platinum", "elite"].includes(pricingTierValue)
    ) {
      return true; // disable for Silver or any other tier
    }

    // 🔒 For non-dealers, ANNEXURE_PARTS is always disabled
    if (customerType !== "Dealer" && access.featureCode === "ANNEXURE_PARTS") {
      return true;
    }

    // 🔒 Disable only for the specific feature codes below
    if (
      access.featureCode === 'SEARCH_EPC' ||
      access.featureCode === 'LIST_BILL_DOC' ||
      access.featureCode === 'ACCOUNT_STATEMENT' ||
      access.featureCode === 'CURT_PREVI_MONTH_SALES' ||
      access.featureCode === 'DOC_EXP'
    ) {
      return true;
    }

    // ✅ Everything else stays enabled
    return false;
  };


  const isAccessParameAdded = (toggledata: any) => {
    if (
      userParameters &&
      userParameters.data &&
      userParameters.data.data &&
      userParameters.data.data.length > 0
    ) {
      let orgIds: any = userParameters.data.data[0].organizationIds;

      const requiredFields = [
        "salesOffice",
        "distributionChannel",
        "salesGroup",
        "salesEmployee",
        "creditControlArea",
      ];

      if (toggledata?.featureCode === "ACCESS_PART") {
        const matchingOrg = orgIds.find(
          (org: any) => org.makeSubType === "ALAC AfterMarket Parts"
        );
        if (matchingOrg) {
          const allFieldsFilled = requiredFields.every(
            (field) => matchingOrg[field] && matchingOrg[field].trim() !== ""
          );
          return allFieldsFilled;
        }
      }

      if (toggledata?.featureCode === "ACCESS_TYRE") {
        const matchingOrg = orgIds.find(
          (org: any) => org.makeSubType === "ALAC Tyres & Batteries"
        );
        if (matchingOrg) {
          const allFieldsFilled = requiredFields.every(
            (field) => matchingOrg[field] && matchingOrg[field].trim() !== ""
          );
          return allFieldsFilled;
        }
      }

      return false; // default if no matching org found
    }

    return false; // default if userParameters not properly defined
  };

  return (
    <Fragment>
      {loading || notfetchedInitialData && <FullscreenLoader />}
      <div className="card col-12 m-0 p-0">
        <div className="row mb-0 px-2">
          <div className="col-12 mt-1">
            <div className="d-flex align-items-center">
              <h5 className="page-sub-title px-2 mt-1">Customer Access</h5>
              <div className="row-space-start ml-auto">
                {isEditDealer && (
                  <Button
                    color="secondary" className="mr-2 text-info"
                    disabled={dealerstatus && dealerstatus === "Deactive" ? true : false}
                    startIcon={<RotateLeftIcon className="font-size-18 mb-1" />}
                    onClick={async () => {
                      const paramsData = await editDealerService.getAllAcessParams();

                      if (
                        paramsData?.data?.[0]?.featureAccessibility
                      ) {
                        let apiData = paramsData.data[0].featureAccessibility;

                        // Step 1: Apply filter condition
                        if (
                          sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer" &&
                          sessionStorage.getItem('customerOnboardingType') !== "Dealer"
                        ) {
                          apiData = filterFeatureData(apiData);
                        }
                        // Step 2: Preserve MANAGE_EXPORT_TO_EXL from existing state
                        const updatedData = apiData.map((item: any) => {
                          if (item.featureCode === "MANAGE_EXPORT_TO_EXL") {
                            const existing = paramsdata?.find(
                              (p: any) => p.featureCode === "MANAGE_EXPORT_TO_EXL"
                            );
                            return existing ? existing : item; // 🔥 THIS IS MISSING
                          }
                          return item;
                        });
                        setparamsdata(updatedData);
                      }
                    }}
                  ><span className="onshiftoparty-font mt-1 mb-2 pr-0">Reset to Default
                    </span>
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card col-12 m-0 p-0">
        <div className="row mb-1 mt-1">
          {paramsdata && paramsdata.map((itemParam: any, index: any) => {
            return <div className="col-sm-12 col-md-4 col-lg-4 px-3 pr-2 mb-2 mt-2 row-space-between border-right">
              <div className="lock-indicator font-size-12 px-2">
                {itemParam.label === "Lubes & IAM Parts" ? 'Part Search' : itemParam.label}
              </div>
              <Typography component="div">
                <Grid component="label" container alignItems="center" spacing={1}>
                  <Grid item>
                    {/* <AntSwitch
                      checked={(formData.customerTierType === 'Workshop' && itemParam.featureCode === "VIEW_CR_STATUS") ? false : itemParam.value}
                      disabled={(itemParam.featureCode === 'MANAGE_EXPORT_TO_EXL') || (formData.customerTierType === 'Workshop' && itemParam.featureCode === "VIEW_CR_STATUS") || (isEditDealer ? isDisabled(itemParam) || dealerstatus && dealerstatus === "Deactive" ? true : false : true)}
                      onChange={(e) => {
                        props.setDataUpdated(true);
                        let paramDataTemp = JSON.parse(JSON.stringify(paramsdata));
                        paramDataTemp[index].value = !itemParam.value
                        setparamsdata(paramDataTemp)
                      }} /> */}

                    <AntSwitch
                      checked={itemParam.value}
                      disabled={
                        (itemParam.featureCode === 'MANAGE_EXPORT_TO_EXL') ||
                        (isAlacAccess === false && (itemParam.featureCode === 'ACCESS_PART' || itemParam.featureCode === "ACCESS_TYRE")) ||
                        (isEditDealer ?
                          isDisabled(itemParam) ||
                          // (itemParam.featureCode === "SALES_RETURN" &&
                          //   sessionStorage.getItem('customerOnboardingType') === "Int. Business"
                          // ) ||
                          ((userType && userType.toLowerCase() === 'fse') || (userType && userType.toLowerCase() === 'superadmin')) ||
                          (dealerstatus && dealerstatus === "Deactive")
                          : true
                        )
                      }
                      onChange={(e) => {
                        props.setDataUpdated(true);
                        let paramDataTemp = JSON.parse(JSON.stringify(paramsdata));
                        if (paramDataTemp[index].featureCode === "ACCESS_TYRE" || paramDataTemp[index].featureCode === "ACCESS_PART") {
                          if (itemParam.value) {
                            paramDataTemp[index].value = !itemParam.value
                            setparamsdata(paramDataTemp)
                          } else {
                            const isParamAdded: any = isAccessParameAdded(paramDataTemp[index])
                            if (isParamAdded) {
                              setOpenCancelDialog(true);
                              paramDataTemp[index].value = !itemParam.value
                              setparamsdata(paramDataTemp)
                            } else {
                              setOpenCancelDialog(true);
                              paramDataTemp[index].value = !itemParam.value
                              setparamsdata(paramDataTemp)
                            }
                          }
                        } else {
                          paramDataTemp[index].value = !itemParam.value
                          setparamsdata(paramDataTemp)
                        }
                      }} />
                  </Grid>
                </Grid>
              </Typography>
            </div>
          })}
        </div>
      </div>
      {isEditDealer && (
        <ActionButtons
          openRequestSnackbar={true}
          deactiveShow={true}
          dealerDetails={dealerDetails}
          dealerStatus={dealerstatus}
          saveCallback={() => {
            saveAccessTab()
          }}
          showSave
          isAlacAccess={isAlacAccess}
        />
      )}
      <CancelDialog
        open={openCancelDialog}
        text="It's important to update the brand parameters so that users can purchase these parts. 
        If the Brand parameters aren't submitted, the Customer user won't be able to move forward with purchasing these Parts.
        Please follow these steps to update. Goto Customers >> Users >> Modify Parameter"
        handleopenClose={handleopenCloseCancelDialog}
        handleCancelConfirmation={handleopenCloseCancelDialog}
        hideYes={true}
        maxWidth="sm"
      />
      <ReturnRequestSnackbar
        open={openSnackbar}
        type={openErrorSnackbar ? 'error' : ''}
        handleopenClose={() => {
          setOpenSnackbar(false)
        }} message={successMessage} />
    </Fragment>
  );
}
